import React from "react";
// import GIT from "../../assets/images/contact-us.png";
const Footer = () => {
  return (
    <div id="Contact" className="mt-12">
      <p className="font-['FuturaMed'] text-sm sm:text-md md:text-lg lg:text-xl xl:text-3xl 2xl:text-4xl text-center text-[#00693A] pb-2 md:pb-3 lg:pb-4 xl:pb-8">
        We value your opinions and remarks, please share your thoughts,
        suggestions, or questions with us.
      </p>
      <div className="bg-[#00693A]  justify-center items-center md:py-4">
        {/* <div
          style={{
            backgroundImage: `url(${GIT})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="min-h-[200px] sm:min-h-[300px] md:min-h-[400px]"
        /> */}
        <p className="font-['FuturaMed'] text-sm sm:text-md md:text-lg lg:text-xl xl:text-4xl text-center p-2 text-white">
          {"Email: "}
          <a href="mailto:greenwavelebanon@gmail.com">
            greenwavelebanon@gmail.com
          </a>
        </p>
        <p className="font-['FuturaMed'] text-sm sm:text-md md:text-lg lg:text-xl xl:text-4xl text-center p-2 text-white">
          {"Phone and WhatsApp: "}+
          <a href="tel:+96176607784" style={{ textDecoration: "underline" }}>
            961 76 607 784
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
